import { render, staticRenderFns } from "./EditKolayIKRecordDialog.vue?vue&type=template&id=2a23588b"
import script from "./EditKolayIKRecordDialog.vue?vue&type=script&lang=js"
export * from "./EditKolayIKRecordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports